import {videoTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = videoTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const videoReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default videoReducer;
